import React, { useRef, useEffect, useCallback } from "react";
import { DropTargetMonitor, useDrop } from "react-dnd";
import Card from "./Card";
import ItemTypes from "./ItemTypes";
import { useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import {
  generateId,
  generateSectionalIds,
  mergeAssetFieldWithFormField,
} from "../../../../../helpers/commonFunction";
import {
  addFormJson,
  removeComponentFromJson,
} from "../../../../../stateManager/store/formCreation/action";
import { PUSH_ACTION_STACK, INITIALIZE_ACTION_STACK } from "../../../../../stateManager/store/formCreation/types";
import { setContextMenuVisibility } from "../../../../../stateManager/store/contextMenu/action";
import { findIdSelector } from "./reduxSelector";
import { fCardSelect } from "../../../../../helpers/RxServices";
import { useToast } from "../../../../../helpers/commonFunction";
import { ContextMenu } from "../../../../../helpers/commonUi";
import { getRandomId } from "../../../../../utils/random-id";
import { addAssetLookupTable } from "../../../../../stateManager/store/assets/action";
import { getAssetLookupTable } from "../../../../../helpers/commonFunction/getAssetLookupTable";

const FormDragLayout = (props: any) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const formDragRef = useRef<HTMLDivElement>(null);
  const params: any = useParams();
  const dispatch = useDispatch();
  const cards = useSelector((state) => {
    return findIdSelector(state, params.formId, [props.tabId]);
  });

  const { list: assets } = useSelector((state: any) => state.assets);

  useEffect(() => {
    const lookupTable: any = {};
    getAssetLookupTable(assets, lookupTable);
    dispatch(addAssetLookupTable(lookupTable))
  }, [assets, dispatch])

  const { WarningToast } = useToast();

  const appInfo = useSelector((state: any) => state.apps.selectedApp);
  const contextVisibility = useSelector((state: any) => state.contextMenu.visibility);
  const thisTab = useSelector((state) => {
    const stateCopy = JSON.parse(JSON.stringify(state));
    return (
      stateCopy.formcreation[params.formId] &&
      stateCopy.formcreation[params.formId][0]
    );
  });
  // component Drop
  const [collectedProps, drop] = useDrop({
    accept: [ItemTypes.BOX, ItemTypes.SECTION],
    drop: (item: any) => {
      if (item.isAsset && item.type === ItemTypes.BOX) {
        if (
          collectedProps.isOverCurrent &&
          (appInfo.type === "a8assist" ||
            (appInfo.type === "a8flow" && (item.json.type === "Section" || item.json.type === "Container")))
        ) {
          //Generate a new ID for the dropped element
          const buffer = cards ? cards : [];
          const idArray =
            buffer.length > 0 &&
            buffer.map((el: any) => {
              // return parseInt(item.id.substring(item.id.length - 1))
              return parseInt(el.id.split("-")[el.id.split("-").length - 1]);
            });
          let newItem: any;
          const idIncrement = idArray.length > 0 ? Math.max(...idArray) + 1 : 0;
          const generatedId = `${props.tabId}#` + item.json.type.toLowerCase() + "-" + idIncrement;
          const componentId = getRandomId();
          const assetInstanceId = getRandomId()
          if (item.json && item.json.fields && item.json.fields.length > 0) {
            newItem = generateSectionalIds(item, generatedId)
          }
          newItem.assetInstanceId = assetInstanceId
          newItem.assetBindPrefix = getRandomId()

          dispatch({
            type: PUSH_ACTION_STACK,
            data: {
              undo: () => {
                dispatch(
                  removeComponentFromJson({
                    formid: params.formId,
                    draggedItemContainer: JSON.parse(JSON.stringify(thisTab)),
                    itemId: generatedId,
                  })
                );
              },
              redo: () => {
                dispatch(
                  addFormJson({
                    formId: params.formId,
                    data: {
                      ...newItem,
                      label: item.label,
                      id: generatedId,
                      componentId
                      // elementId: elementId,
                    },
                  })
                );
              },
            },
          });
          dispatch(
            addFormJson({
              formId: params.formId,
              data: {
                ...newItem,
                label: item.label,
                id: generatedId,
                // elementId: elementId,
                componentId
              },
            })
          );
        } else if (item.type !== ItemTypes.SECTION || item.type !== ItemTypes.CONTAINER) {
          WarningToast(
            "Components can be placed inside the section and container only"
          );
        }
      } else if (item.type === ItemTypes.BOX) {
        const componentId = getRandomId();
        if (
          collectedProps.isOverCurrent &&
          (appInfo.type === "a8assist" ||
            (appInfo.type === "a8flow" && (item.json.type === "Section" || item.json.type === "Container")))
        ) {
          //Generate a new ID for the dropped element
          const buffer = cards ? cards : [];
          const idArray =
            buffer.length > 0 &&
            buffer.map((el: any) => {
              // return parseInt(item.id.substring(item.id.length - 1))
              return parseInt(el.id.split("-")[el.id.split("-").length - 1]);
            });
          const idIncrement = idArray.length > 0 ? Math.max(...idArray) + 1 : 0;
          const generatedId = `${props.tabId}#` + item.id + "-" + idIncrement;
          const elementId = getRandomId();

          dispatch({
            type: PUSH_ACTION_STACK,
            data: {
              undo: () => {
                dispatch(
                  removeComponentFromJson({
                    formid: params.formId,
                    draggedItemContainer: JSON.parse(JSON.stringify(thisTab)),
                    itemId: generatedId,
                  })
                );
              },
              redo: () => {
                dispatch(
                  addFormJson({
                    formId: params.formId,
                    data: {
                      ...item.json,
                      label: item.label,
                      id: generatedId,
                      elementId: elementId,
                    },
                  })
                );
              },
            },
          });
          dispatch(
            addFormJson({
              formId: params.formId,
              data: {
                ...item.json,
                label: item.label,
                id: generatedId,
                elementId: elementId,
                componentId
              },
            })
          );
        } else if (item.type !== ItemTypes.SECTION || item.type !== ItemTypes.CONTAINER) {
          WarningToast(
            "Components can be placed inside the section and container only"
          );
        }
      } else if (
        item.type === ItemTypes.SECTION &&
        collectedProps.isOverCurrent
      ) {
        const componentId = getRandomId();
        const newId = generateId(item, { json: thisTab });
        const itemWithNewIds = generateSectionalIds(item, newId);
        itemWithNewIds.componentId = componentId;

        const addData = {
          formid: params.formId,
          droppedContainer: { json: JSON.parse(JSON.stringify(thisTab)) },
          draggedItem: itemWithNewIds,
        };

        const undoAddData = {
          formid: params.formId,
          draggedItemContainer: JSON.parse(JSON.stringify(thisTab)),
          itemId: newId,
        };
        return { isDragComplete: true, addData, undoAddData };
      }
    },
    canDrop: (item) => {
      //Prevents drops happening within the same container
      if (collectedProps.isOverCurrent) {
        if (item.id && item.id.startsWith("tab-0")) {
          if (item.id.split("#").length > 1) {
            return true;
          }
          return false;
        }
        return true;
      }
      return false;
    },
    collect: (monitor: DropTargetMonitor) => ({
      draggedItem: monitor.getItem(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      isOverCurrent: monitor.isOver({ shallow: true }),
    }),
  });
  const handleClickOutside = useCallback(
    (event: any) => {
      if (
        wrapperRef &&
        wrapperRef.current &&
        !wrapperRef.current!.contains(event.target)
      ) {
        // fCardSelect.sendMessage({ id: undefined });
      }
      if (wrapperRef.current === event.target) {
        fCardSelect.sendMessage({ id: undefined });
      }
    },
    [wrapperRef]
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  const contextMenuListener = useCallback((e: any) => {
    if (formDragRef && formDragRef.current) {
      e.preventDefault();

      const rect = formDragRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      dispatch(
        setContextMenuVisibility({
          visibility: true,
          coordinates: {
            top: y + 55,
            left: x,
          },
        })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    const tab = document.getElementById(`render_${props.tabId}`);
    if (tab && tab.getAttribute("contextlistener") !== "true") {
      tab.addEventListener("contextmenu", contextMenuListener);
      if (tab) {
        tab.setAttribute("contextlistener", "true");
      }
    }
    return () => {
      if (tab) {
        tab.removeEventListener("contextmenu", contextMenuListener);
        tab.setAttribute("contextlistener", "false");
      }
    };
  }, [contextMenuListener, props.tabId])

  const clickListener = useCallback((e: any) => {
    if (e.target.id !== "contextMenuItem" && contextVisibility) {
      dispatch(setContextMenuVisibility({
        visibility: false,
        coordinates: {},
      }))
    }
  }, [contextVisibility, dispatch])


  const getAssetField = (field: any) => {
    const aId = field.assetId

    if (aId && assets[aId] && assets[aId].json && field.elementId === assets[aId].json.elementId) {
      const assetCopy = JSON.parse(JSON.stringify(assets[aId].json))
      const fieldCopy = JSON.parse(JSON.stringify(field))
      return mergeAssetFieldWithFormField(assetCopy, fieldCopy)
    }

    return field
  }

  useEffect(() => {
    const root = document.getElementById("root")

    if (root && root.getAttribute("clickListener") !== "true") {
      root.addEventListener("click", clickListener);
      root.setAttribute("clickListener", "true");
    }

    return () => {
      if (root) {
        root.removeEventListener("click", clickListener);
        root.setAttribute("clickListener", "false");
      }
    };
    // eslint-disable-next-line
  }, [clickListener])

  useEffect(() => {
    dispatch({
      type: INITIALIZE_ACTION_STACK,
    });
  }, [dispatch]);

  // const moveCard = (
  //     (id: string, atIndex: number) => {
  //         const { card, index } = findCard(id);
  //         if (card) {
  //             let Localcards = (cards);
  //             Localcards.splice(index, 1);
  //             Localcards.splice(atIndex, 0, card)
  //             // setCards([...Localcards])
  //         }

  //     }
  // )
  // const findCard = (id: string) => {
  //     const card = (cards).filter((c: any) => `${c.id}` === id.toString())[0]
  //     return {
  //         card,
  //         index: findIndex(cards, card),
  //     }
  // }
  const isActive = collectedProps.isOverCurrent && collectedProps.draggedItem && collectedProps.draggedItem.json.type === "Section"

  let backgroundStyle: React.CSSProperties = {
    height: "calc(100vh - 170px)",
    overflowY: "scroll",
    display: "block",
    padding: "0 15px 15px 15px",
    border: isActive ? "3px dashed" : "",
    borderColor: isActive ? "#c5e1a5" : "white"
  };
  let backgroundColor = thisTab.backgroundColor;
  if (backgroundColor) {
    backgroundStyle = { ...backgroundStyle, backgroundColor: backgroundColor };
  } else {
    let backgroundImage = thisTab.backgroundImage;
    if (backgroundImage) {
      backgroundStyle = {
        ...backgroundStyle,
        backgroundImage: `url(${backgroundImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        height: "inherit",
        backgroundPosition: "center",
      };
    }
  }

  return (
    <div ref={formDragRef} id={`render_${props.tabId}`}>
      {props.canEdit && <ContextMenu />}
      <div
        ref={props.canEdit ? drop : null}
        className="override-collapse"
        style={{ ...backgroundStyle }}
      >
        <div className="row">
          {cards &&
            cards.map((res: any) => {
              const updatedRes = getAssetField(res);
              return (
                <Card
                  data-test-id="card"
                  key={updatedRes.id}
                  id={updatedRes.id}
                  canEdit={props.canEdit}
                  name={updatedRes.label}
                  JsonData={updatedRes}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default React.memo(FormDragLayout);
